import {
  CreateTransactionResponse,
  Transaction,
  TransactionRequestBody,
  UpdateTransactionAnswersRequest,
  UpdateTransactionCommentRequest,
  UpdateTransactionDesignationRequest,
  UpdateTransactionEmployerMatchRequest,
} from 'models/Transaction'
import { api } from '../api'

export const transactionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createTransaction: builder.mutation<
      CreateTransactionResponse,
      { campaignId: string; transaction: TransactionRequestBody }
    >({
      query: ({ campaignId, transaction }) => ({
        method: 'POST',
        url: `campaigns/${campaignId}/transactions`,
        body: transaction,
      }),
    }),

    updateTransactionAnswers: builder.mutation<
      Transaction,
      {
        transactionId: string
        transactionToken: string
        transactionAnswers: UpdateTransactionAnswersRequest['body']
      }
    >({
      query: ({ transactionId, transactionToken, transactionAnswers }) => ({
        method: 'PUT',
        url: `transactions/${transactionId}/answers`,
        body: transactionAnswers,
        headers: {
          transaction_token: transactionToken,
        },
      }),
    }),

    updateTransactionComment: builder.mutation<
      Transaction,
      {
        transactionId: string
        transactionToken: string
        transactionComment: UpdateTransactionCommentRequest['body']
      }
    >({
      query: ({ transactionId, transactionToken, transactionComment }) => ({
        method: 'PUT',
        url: `transactions/${transactionId}/comment`,
        body: transactionComment,
        headers: {
          transaction_token: transactionToken,
        },
      }),
    }),

    updateTransactionEmployerMatch: builder.mutation<
      Transaction,
      {
        transactionId: string
        transactionToken: string
        transactionEmployerMatch: UpdateTransactionEmployerMatchRequest['body']
      }
    >({
      query: ({ transactionId, transactionToken, transactionEmployerMatch }) => ({
        method: 'PUT',
        url: `transactions/${transactionId}/employer-match`,
        body: transactionEmployerMatch,
        headers: {
          transaction_token: transactionToken,
        },
      }),
    }),

    updateTransactionDesignation: builder.mutation<
      Transaction,
      {
        transactionId: string
        transactionToken: string
        transactionDesignation: UpdateTransactionDesignationRequest['body']
      }
    >({
      query: ({ transactionId, transactionToken, transactionDesignation }) => ({
        method: 'PUT',
        url: `transactions/${transactionId}/designation`,
        body: transactionDesignation,
        headers: {
          transaction_token: transactionToken,
        },
      }),
    }),
  }),
})

export const {
  endpoints: {
    createTransaction,
    updateTransactionAnswers,
    updateTransactionComment,
    updateTransactionEmployerMatch,
    updateTransactionDesignation,
  },
} = transactionsApi
